import React from 'react';
import { useParams, Link } from 'react-router-dom';

const specialties = [
  {
    id: 'general',
    title: 'General Dentistry',
    description: 'Comprehensive dental care for patients of all ages, focusing on preventive care and overall oral health.',
    icon: '🦷',
    image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=800&auto=format&fit=crop&q=60',
    features: [
      'Preventive Care',
      'Restorative Treatments',
      'Emergency Services',
      'Regular Check-ups'
    ],
    longDescription: `General dentistry is the foundation of dental care, focusing on maintaining optimal oral health for patients of all ages. Our general dentistry services encompass a wide range of preventive and restorative treatments designed to keep your smile healthy and beautiful.

    Our team of experienced general dentists provides comprehensive care, from routine check-ups to complex restorative procedures. We believe in a preventive approach to dental care, helping you maintain a healthy smile for life.`,
    services: [
      {
        title: 'Preventive Care',
        description: 'Regular check-ups, cleanings, and screenings to prevent dental issues before they develop.'
      },
      {
        title: 'Restorative Treatments',
        description: 'Fillings, crowns, and other treatments to restore damaged teeth to their natural function and appearance.'
      },
      {
        title: 'Emergency Services',
        description: 'Prompt care for dental emergencies, including pain relief and immediate treatment.'
      },
      {
        title: 'Regular Check-ups',
        description: 'Comprehensive examinations and professional cleanings to maintain optimal oral health.'
      }
    ]
  },
  {
    id: 'orthodontics',
    title: 'Orthodontics',
    description: 'Specialized care for teeth alignment and bite correction using advanced orthodontic solutions.',
    icon: '😁',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Traditional Braces',
      'Clear Aligners',
      'Retainers',
      'Early Intervention'
    ],
    longDescription: `Orthodontics is a specialized branch of dentistry that focuses on correcting teeth alignment and bite issues. Our orthodontic treatments are designed to create beautiful, functional smiles through various treatment options.

    Whether you're considering traditional braces or modern clear aligners, our orthodontic specialists will work with you to develop a personalized treatment plan that meets your needs and goals.`,
    services: [
      {
        title: 'Traditional Braces',
        description: 'Metal or ceramic braces for comprehensive teeth alignment and bite correction.'
      },
      {
        title: 'Clear Aligners',
        description: 'Nearly invisible aligners for discreet orthodontic treatment.'
      },
      {
        title: 'Retainers',
        description: 'Custom-fitted retainers to maintain your new smile after treatment.'
      },
      {
        title: 'Early Intervention',
        description: 'Early orthodontic evaluation and treatment for children to prevent future issues.'
      }
    ]
  },
  {
    id: 'cosmetic',
    title: 'Cosmetic Dentistry',
    description: 'Transform your smile with our advanced cosmetic dental procedures and treatments.',
    icon: '✨',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Teeth Whitening',
      'Veneers',
      'Dental Bonding',
      'Smile Makeovers'
    ],
    longDescription: `Cosmetic dentistry focuses on enhancing the appearance of your smile through various advanced procedures. Our cosmetic dental treatments are designed to address aesthetic concerns while maintaining optimal oral health.

    From simple whitening treatments to complete smile makeovers, our cosmetic dentists will help you achieve the smile you've always wanted.`,
    services: [
      {
        title: 'Teeth Whitening',
        description: 'Professional whitening treatments for a brighter, more confident smile.'
      },
      {
        title: 'Veneers',
        description: 'Thin, custom-made shells to improve the appearance of your teeth.'
      },
      {
        title: 'Dental Bonding',
        description: 'Tooth-colored resin to repair chips, cracks, and gaps.'
      },
      {
        title: 'Smile Makeovers',
        description: 'Comprehensive treatment plans to transform your entire smile.'
      }
    ]
  },
  {
    id: 'pediatric',
    title: 'Pediatric Dentistry',
    description: 'Specialized dental care for children, creating a positive and comfortable dental experience.',
    icon: '👶',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Child-Friendly Environment',
      'Preventive Care',
      'Early Education',
      'Growth Monitoring'
    ],
    longDescription: `Pediatric dentistry is dedicated to the oral health of children from infancy through adolescence. Our pediatric dental team creates a welcoming, fun environment where children can feel comfortable and safe during their dental visits.

    We focus on preventive care and education, helping children develop healthy dental habits that will last a lifetime.`,
    services: [
      {
        title: 'Child-Friendly Environment',
        description: 'A welcoming atmosphere designed to make children feel comfortable and safe.'
      },
      {
        title: 'Preventive Care',
        description: 'Regular check-ups, cleanings, and fluoride treatments to prevent dental issues.'
      },
      {
        title: 'Early Education',
        description: 'Fun, interactive lessons about proper oral hygiene and dental health.'
      },
      {
        title: 'Growth Monitoring',
        description: 'Regular monitoring of dental development and growth patterns.'
      }
    ]
  },
  {
    id: 'endodontics',
    title: 'Endodontics',
    description: 'Expert root canal treatment and care for the dental pulp and surrounding tissues.',
    icon: '🔬',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Root Canal Therapy',
      'Pulp Treatment',
      'Trauma Care',
      'Pain Management'
    ],
    longDescription: `Endodontics focuses on the diagnosis and treatment of issues affecting the dental pulp and surrounding tissues. Our endodontic specialists are experts in saving teeth through advanced root canal therapy and other treatments.

    We use state-of-the-art technology and techniques to ensure comfortable, effective treatment for even the most complex cases.`,
    services: [
      {
        title: 'Root Canal Therapy',
        description: 'Advanced treatment to save infected or damaged teeth.'
      },
      {
        title: 'Pulp Treatment',
        description: 'Specialized care for the soft tissue inside your teeth.'
      },
      {
        title: 'Trauma Care',
        description: 'Emergency treatment for dental injuries and trauma.'
      },
      {
        title: 'Pain Management',
        description: 'Comprehensive pain management during and after treatment.'
      }
    ]
  },
  {
    id: 'periodontics',
    title: 'Periodontics',
    description: 'Specialized care for gum health and treatment of periodontal diseases.',
    icon: '🦷',
    image: 'https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&auto=format&fit=crop&q=60',
    features: [
      'Gum Disease Treatment',
      'Dental Implants',
      'Gum Surgery',
      'Maintenance Care'
    ],
    longDescription: `Periodontics specializes in the prevention, diagnosis, and treatment of gum disease and other conditions affecting the supporting structures of the teeth. Our periodontal team provides comprehensive care for gum health and dental implants.

    We use the latest techniques and technology to ensure optimal results and long-term success.`,
    services: [
      {
        title: 'Gum Disease Treatment',
        description: 'Comprehensive treatment for various stages of gum disease.'
      },
      {
        title: 'Dental Implants',
        description: 'Advanced implant placement and restoration procedures.'
      },
      {
        title: 'Gum Surgery',
        description: 'Surgical procedures to treat gum disease and improve gum health.'
      },
      {
        title: 'Maintenance Care',
        description: 'Ongoing care and monitoring to maintain gum health.'
      }
    ]
  }
];

const SpecialtyDetail = () => {
  const { id } = useParams();
  const specialty = specialties.find(s => s.id === id);

  if (!specialty) {
    return (
      <div className="pt-24 min-h-screen bg-gray-50">
        <div className="container mx-auto px-6 py-16">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-[#1E2A4A] mb-4">Specialty Not Found</h1>
            <p className="text-xl text-gray-600 mb-8">The requested specialty could not be found.</p>
            <Link 
              to="/specialties"
              className="inline-block bg-orange-500 text-white px-8 py-4 rounded-xl font-semibold hover:bg-orange-600 transition-colors"
            >
              Back to Specialties
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-24 min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-b from-[#E5F0F3] to-white">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center justify-center mb-8">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center text-4xl shadow-lg">
                {specialty.icon}
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-[#1E2A4A] text-center mb-6">
              {specialty.title}
            </h1>
            <p className="text-xl text-gray-600 text-center">
              {specialty.description}
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Image Section */}
          <div className="mb-12">
            <img 
              src={specialty.image} 
              alt={specialty.title}
              className="w-full h-96 object-cover rounded-2xl shadow-xl"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://via.placeholder.com/800x600?text=Dental+Specialty';
              }}
            />
          </div>

          {/* Description */}
          <div className="prose prose-lg max-w-none mb-12">
            <p className="text-gray-600 leading-relaxed">
              {specialty.longDescription}
            </p>
          </div>

          {/* Services */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-[#1E2A4A] mb-8">Our Services</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {specialty.services.map((service, index) => (
                <div 
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow"
                >
                  <h3 className="text-xl font-bold text-[#1E2A4A] mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600">
                    {service.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-[#1E2A4A] text-white p-8 rounded-2xl text-center">
            <h2 className="text-2xl font-bold mb-4">
              Ready to Experience Expert {specialty.title}?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Schedule a consultation with our specialists today
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/schedule-demo"
                className="inline-block bg-orange-500 text-white px-8 py-4 rounded-xl font-semibold hover:bg-orange-600 transition-colors"
              >
                Schedule a Consultation
              </Link>
              <Link 
                to="/specialties"
                className="inline-block bg-white text-[#1E2A4A] px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-colors"
              >
                Back to Specialties
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialtyDetail; 